import {useState, useRef} from 'preact/hooks';
import classes from '../styles/index.module.css';
import '../styles/globals.css';
import background from '../assets/background.png';
import gongan from '../assets/gongan.png';
import Image from '../component/Image';
import Tools from '../component/Tools';
import Scientific from '../component/Scientific';
import Service from '../component/Service';
import About from '../component/About';
import Login from '../component/Login';
import Menu from '../component/Menu';
export default function Home() {
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <div>
            <header className={classes.header}>
                <div className={classes.logo}>
                    <Image width={100} height={40}
                           src={`${process.env.PREACT_APP_STATIC_URL}/jeean-logo/jeean-cloud-logo-gov.svg`}
                           alt=""/>
                </div>
                <div className={classes.nav}>
                    <Menu
                        scrollTo
                        affix={false}
                        targetOffset={64}
                        direction="horizontal"
                        defaultSelectedKeys='0'
                        items={[
                            {
                                key: '1',
                                href: '#Tools',
                                label: '工具',
                            },
                            {
                                key: '2',
                                href: '#Scientific',
                                label: '科研',
                            },
                            {
                                key: '3',
                                href: '#Service',
                                label: '服务',
                            },
                            {
                                key: '4',
                                href: '#About',
                                label: '关于',
                            },
                        ]}
                    />
                    <Menu
                        defaultSelectedKeys='0'
                        scrollTo={false}
                        items={[
                            {
                                key: '5',
                                label:
                                    <a  href="/downloadapp/23" target="_blank">APP下载</a>
                            },
                            {
                                key: '6',
                                label: <a type="link" href="/register" target="_blank">注册</a>,
                            },
                            {
                                key: '7',
                                label: <a type="link" onClick={() => setIsModalOpen(true)}>登录</a>,
                            }
                        ]}
                    />
                </div>
            </header>
            <main className={classes.content}>
                <div className={classes.banner}>
                    <Image
                        src={background}
                        alt="banner"
                        width={1280}
                        height={700}
                        priority
                    />
                </div>
                <Tools id="Tools" />
                <Scientific id="Scientific" />
                <Service id="Service"/>
                <About id="About"/>
            </main>
            <footer
                style={{
                    width: '100%',
                    height: 70,
                    borderTop: '3px solid #f3f3f3',
                    overflow: 'hidden',
                    fontSize: 13,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                <span>©2015-2017 北京星度科技有限公司 all Right reserved |</span>
                <a style={{color: '#0095e2'}} type="link" target="_blank"
                   href="http://beian.miit.gov.cn">京ICP备14031847-1</a>

                <Image height={20} src={gongan} alt=""/>
                <a style={{color: '#0095e2'}} type="link" target="_blank"
                   href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502042659">
                    京公网安备 11010502042659
                </a>
            </footer>
            {
                isModalOpen &&
                <Login setIsModalOpen={setIsModalOpen}/>

            }
        </div>
    )
}
